import React, { FunctionComponent } from 'react';
import { SelectSingleComponent } from '@companion-professional/components';
import { CheckupTag } from '@companion-professional/dctypes';
import { snakeToSentenceCase } from '@companion-professional/webutils';

interface CheckupLocationSelectionProps {
  // onTagSelect is a function called when a location tag is selected.
  onTagSelect: (tag: CheckupTag) => Promise<void>;

  // locationTags are the location tags that the user can select from to create a checkup.  Only one location tag can be
  // selected, and the handleCreateCheckup function will be called with the selected location tag.
  locationTags: CheckupTag[];

  // selectedCheckupTags are the tags that are associated with the checkup.  If the tag is in the selectedCheckupTags
  // array, then the button will be styled as selected.
  selectedCheckupTags?: CheckupTag[];
}

// CheckupLocationSelection is a component that displays a list of location tag buttons that the user can select from.
// When a location tag is selected, the onTagSelect function is called with the selected location tag.
export const CheckupLocationSelection: FunctionComponent<CheckupLocationSelectionProps> = ({
  onTagSelect,
  locationTags,
  selectedCheckupTags
}) => {
  const selectValues = locationTags.map((tag) => ({
    value: tag,
    label: snakeToSentenceCase(tag)
  }));

  // Note: we return an empty string if no tag is selected because the SelectSingleComponent expects a string value and
  // will not show the placeholder if the value is undefined or null.
  const firstSelectedTag = locationTags.find((tag) => selectedCheckupTags?.includes(tag)) || '';

  return (
    <div className="flex w-full flex-row gap-2">
      <SelectSingleComponent
        name="location"
        placeholder="Select a location"
        options={selectValues}
        value={firstSelectedTag}
        onChange={(tag) => {
          if (selectedCheckupTags?.includes(tag)) {
            return;
          }
          return onTagSelect(tag);
        }}
      />
    </div>
  );
};
